import React from 'react'
import {withRouter} from 'react-router-dom'
import MenuCategoryListView from './MenuCategoryListView'
import openPhotoSwipe from '../../react/openPhotoSwipeGallery'
import {Consumer} from '../../react/ShopDataContainer'
import {Helmet} from 'react-helmet'
// import AutoMenuNavigator from './AutoMenuNavigator'



class AutoMenu extends React.PureComponent {
  constructor() {
    super();
    let records = []

    this.state = { menu: records, info: {}, galleryIsOpen: false };
    this.openPhotoSwipeGallery = this.openPhotoSwipeGallery.bind(this)
    this.onAddCurrentSlideToCart = this.onAddCurrentSlideToCart.bind(this)

    this.focusRef = React.createRef()
  }

  componentDidMount () {
    let productIdToFocus = null
    try {
      productIdToFocus = window['product-id-to-focus']
      // console.log(productIdToFocus)
    } catch(e) {}

    if (!productIdToFocus && this.props.shouldFocus) {
      try {
        console.log('focusing to menu')
        this.focusRef.current.focus()
      } catch(e) {
      }
    }

    if (productIdToFocus && this.props.shouldFocus) {
      console.log('🐞 focusing: ' + productIdToFocus)
      try { window['product-id-to-focus'] = null } catch(e) {}
      try {

        const productEle = document.querySelector(`#p_${productIdToFocus}`)
        productEle.setAttribute('tabindex', '-1')
        productEle.focus()
        productEle.scrollIntoView()
      } catch(e) {
        console.log(e)
      }
    }
  }

  onAddCurrentSlideToCart() {
    // console.log('clicked')
    if (!this.gallery) { return }
    let product = this.gallery.currItem && this.gallery.currItem.product
    // let cartItemId = global.__addToCart(product)
    this.gallery.close()
    this.props.history.push(`/products/${product.id}`)

  }
  openPhotoSwipeGallery(productId) {
    let allProducts = []
    this.props.menu.subMenus.forEach(({products}) => allProducts = [...allProducts, ...products])
    let gallery = openPhotoSwipe(productId, allProducts)
    this.gallery = gallery
    this.setState({ galleryIsOpen: true })
    gallery.listen('close', () => {
      this.setState({ galleryIsOpen: false })
      this.gallery = null
    })

  }

  render() {
    console.log('rendering long ass menu')

    let {menu, settings} = this.props
    settings = settings || {}

    if (!menu || !menu.subMenus) {return null}

    const {name, address} = {}

    let subMenus = menu.subMenus

    let promoItems = []
    subMenus.forEach(({products})=> {
      products.forEach((p) => {
        if (p.tags && p.tags.indexOf('bogo') !== -1) {
          promoItems.push(p)
        }
      })
    })

    // filter based on ids
    if (this.props.categorysToShow) {
      subMenus = subMenus.filter(({id}) => {
        return (this.props.categorysToShow.indexOf(id) > -1)
      })
    }
    // filter based on name
    if (this.props.legacy__namesToShow) {
      subMenus = subMenus.filter(({name}) => {
        return (this.props.legacy__namesToShow.indexOf(name) > -1)
      })
    }

    if (this.props.tagsToShow) {
      subMenus = subMenus.filter(({tag}) => {
        if (!tag) { return false}
        let hasTag = false
        this.props.tagsToShow.forEach((tagToShow) => {
          hasTag = tag.indexOf(tagToShow) !== -1
          if (hasTag) { return false }
        })
        return hasTag
      })
    }

    if (this.props.subMenuFilter) {
      subMenus = subMenus.filter(this.props.subMenuFilter)
    }
    if (this.props.subMenuDisableFilter) {
      subMenus = subMenus.map(this.props.subMenuDisableFilter)
    }

    if (this.props.shopId) {
      subMenus = subMenus.filter(({shopId}) => {
        return this.props.shopId === shopId
      })
    }

    return (<div className="menu-story" aria-label="online ordering menu" role="main">

      <Helmet>
        <title>Order Online </title>
      </Helmet>

      <header
        role="presentation"
        style={{
          opacity: 0,
          height: 0
        }}

        >

        <h2
          tabIndex={-1}
          ref={this.focusRef}
          >Ordering Menu</h2>
      </header>

      {/* <AutoMenuNavigator
        subMenus={subMenus}
      /> */}

      <section aria-label="menu sections">
        {/* promos */}
        <div
          aria-labelledby={`menu-category-promos`}
            className={"category"} key={"BOGO!"}>

            <header 
              role="banner"
              className="category__header">
              <h3
                id={`menu-category-promos`}
                className="category-name">
                <span className="text">{"BOGO!"}</span>
              </h3>

               <p className="category__description">
                "Buy One Get One Free"
              </p>
            </header>



            <MenuCategoryListView
              categoryName={"BOGO!"}
              items={promoItems}
              width={180}
              openPhotoSwipeGallery={this.openPhotoSwipeGallery}
            />

          </div>



        {subMenus
            .map(({id, name, products, description, disableOrder, tag}) => {
            if (this.props.disableOrder) {
              disableOrder = true
            }
            if (this.props.productFilter) {
              products = products.filter((product) => {
                return this.props.productFilter(product, {name})
              })
            }
            const tagCSS = tag ? ` ${tag}` : ""
            return(
              <div
              aria-labelledby={`menu-category-${id}`}
                className={"category" + tagCSS} key={name && name.en}>

                <header 
                  role="banner"
                  className="category__header">
                  <h3
                    id={`menu-category-${id}`}
                    className="category-name">
                    <span className="text">{name && name.en}</span>
                  </h3>

                  {description && <p className="category__description">
                    {description && description.en}
                  </p>}
                </header>



                <MenuCategoryListView
                  categoryName={name && name.en}
                  disableOrder={disableOrder}
                  items={products}
                  width={this.props.width || 180}
                  openPhotoSwipeGallery={this.openPhotoSwipeGallery}
                />

              </div>
            )
          })
        }



      </section>

      {/* {this.state.galleryIsOpen && <PhotoswipePortal
        onAddCurrentSlideToCart={this.onAddCurrentSlideToCart}
      />} */}
      {this.state.galleryIsOpen && <div className="test-test">
        <button onClick={this.onAddCurrentSlideToCart}>Add To Cart</button>
      </div>}
    </div>)


  }
}

// const AutoMenuWithRouter = withRouter(AutoMenu)
const AutoMenuWithRouter = withRouter(AutoMenu)
const WithContext = (props) => {
  return(
    <Consumer>
      {({menu, settings}) => {
        return(<AutoMenuWithRouter {...props} menu={menu} settings={settings}></AutoMenuWithRouter>)
      }}
    </Consumer>
  )
}

export default WithContext
